import { useState } from "react";
import { Instagram, Youtube, Twitter, ArrowRight } from "lucide-react";

const COLUMNS = [
  { title: "Product", links: ["Features", "How It Works", "Pricing"], hrefs: ["#features", "#how-it-works", "#pricing"] },
  { title: "Company", links: ["About Coach Arjun", "Transformations", "FAQ"], hrefs: ["#coach", "#results", "#faq"] },
  { title: "Support", links: ["Help Center", "Contact", "Terms"], hrefs: ["#", "#", "#"] },
];

export const Footer = () => {
  const [email, setEmail] = useState("");

  return (
    <footer className="relative border-t border-[#232326] bg-[#0A0A0B] pt-16 pb-24 md:pb-10 px-6 overflow-hidden">
      <span className="absolute -bottom-10 left-1/2 -translate-x-1/2 font-display text-[22vw] sm:text-[14rem] text-white/[0.025] whitespace-nowrap pointer-events-none select-none">
        FORGE
      </span>

      <div className="relative max-w-6xl mx-auto">
        <div className="grid md:grid-cols-[1.4fr_1fr_1fr_1fr] gap-10 pb-12 border-b border-[#232326]">
          <div className="max-w-sm">
            <span className="font-display text-2xl text-white">FORGE</span>
            <p className="text-[#A1A1AA] text-sm mt-3">
              AI-powered Indian diet plans, workouts and tracking — built by Coach Arjun.
            </p>
            <form
              data-testid="footer-newsletter-form"
              onSubmit={(e) => e.preventDefault()}
              className="flex mt-6 bg-[#141416] border border-[#232326] rounded-full p-1.5 max-w-xs"
            >
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Your email"
                data-testid="footer-newsletter-email"
                className="bg-transparent text-white text-sm placeholder:text-[#A1A1AA] px-3 py-1.5 flex-1 outline-none min-w-0"
              />
              <button
                type="submit"
                data-testid="footer-newsletter-submit"
                aria-label="Subscribe"
                className="tap-target !min-h-[36px] !min-w-[36px] bg-[#C6FF3D] text-black rounded-full flex items-center justify-center hover:scale-105 transition-transform duration-300 flex-shrink-0"
              >
                <ArrowRight size={16} />
              </button>
            </form>
            <div className="flex gap-2 mt-6">
              <a href="#" data-testid="footer-social-instagram" aria-label="Instagram" className="tap-target flex items-center justify-center text-[#A1A1AA] hover:text-[#C6FF3D] transition-colors">
                <Instagram size={20} />
              </a>
              <a href="#" data-testid="footer-social-youtube" aria-label="YouTube" className="tap-target flex items-center justify-center text-[#A1A1AA] hover:text-[#C6FF3D] transition-colors">
                <Youtube size={20} />
              </a>
              <a href="#" data-testid="footer-social-twitter" aria-label="Twitter" className="tap-target flex items-center justify-center text-[#A1A1AA] hover:text-[#C6FF3D] transition-colors">
                <Twitter size={20} />
              </a>
            </div>
          </div>

          {COLUMNS.map((col) => (
            <nav key={col.title}>
              <p className="text-white text-sm font-semibold mb-4">{col.title}</p>
              <div className="flex flex-col gap-3">
                {col.links.map((label, i) => (
                  <a key={label} href={col.hrefs[i]} className="text-[#A1A1AA] hover:text-white text-sm transition-colors">
                    {label}
                  </a>
                ))}
              </div>
            </nav>
          ))}
        </div>
        <p className="text-[#A1A1AA]/60 text-xs text-center mt-8">© FORGE by Coach Arjun</p>
      </div>
    </footer>
  );
};
